var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Notification, Property 2=ON"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009333"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17 8.66699C17 7.34091 16.4732 6.06914 15.5355 5.13146C14.5979 4.19378 13.3261 3.66699 12 3.66699C10.6739 3.66699 9.40215 4.19378 8.46447 5.13146C7.52678 6.06914 7 7.34091 7 8.66699C7 14.5003 4.5 16.167 4.5 16.167H19.5C19.5 16.167 17 14.5003 17 8.66699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.4419 19.5C13.2954 19.7526 13.0851 19.9622 12.8321 20.1079C12.5791 20.2537 12.2922 20.3304 12.0003 20.3304C11.7083 20.3304 11.4214 20.2537 11.1684 20.1079C10.9154 19.9622 10.7051 19.7526 10.5586 19.5",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectNotification);
export default __webpack_public_path__ + "static/media/select-notification.a6c261a133448d093fb7f1751eb639e8.svg";
export { ForwardRef as ReactComponent };